import React, { useState, useEffect, useRef } from "react";
import { toFormatPrice, toUnformatPrice } from "../helpers/function";
import { useTranslation } from 'react-i18next';
const DECIMAL_INPUT = /^\d*\.?\d*$/;
const roundText = (value, decimals) =>
  Number.isFinite(value) ? String(Number(value.toFixed(decimals))) : "";
const NotesModalAccounting = (props) => {
  const { t } = useTranslation();
  const { setForm_note, settotalamount, setShipping, setTax, data_product } = props;
  let handleChange = (e) => {
    setForm_note(e.target.value);
  };
  const [taxs, setTaxs] = useState();
  const [taxAmount, setTaxAmount] = useState();
  const [shippings, setShippings] = useState();
  const [note, setNote] = useState();
  // tax % is the saved value; keep it unrounded so a typed tax amount round-trips exactly
  const taxPercentRef = useRef(0);
  const subtotal = toUnformatPrice(settotalamount) || 0;
  const amountFromPercent = (percent) => roundText((subtotal * (Number(percent) || 0)) / 100, 2);

  useEffect(() => {
    if (data_product) {
      const percent = Number(data_product?.tax_percent) || 0;
      taxPercentRef.current = percent;
      setTaxs(percent ? roundText(percent, 4) : "");
      setTaxAmount(percent ? amountFromPercent(percent) : "");
      setShippings(data_product?.shipping_handling_amount === 0 ? 0 : data_product?.shipping_handling_amount);
      setNote(data_product?.note);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data_product]);

  // rows changed -> keep the % and recalculate the tax amount
  useEffect(() => {
    if (taxPercentRef.current) {
      setTaxAmount(amountFromPercent(taxPercentRef.current));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subtotal]);

  const onTaxPercentChange = (value) => {
    if (!DECIMAL_INPUT.test(value)) return;
    const percent = parseFloat(value) || 0;
    taxPercentRef.current = percent;
    setTaxs(value);
    setTaxAmount(value === "" ? "" : amountFromPercent(percent));
    setTax(percent);
  };

  const onTaxAmountChange = (value) => {
    if (!DECIMAL_INPUT.test(value)) return;
    const percent = subtotal ? ((parseFloat(value) || 0) / subtotal) * 100 : 0;
    taxPercentRef.current = percent;
    setTaxAmount(value);
    setTaxs(value === "" ? "" : roundText(percent, 4));
    setTax(percent);
  };
  const base_url = process.env.REACT_APP_BASE_ASSETS_URL;
  return (
    <div
      className="modal notes-modal notes-modal-account"
      id="notesModal"
      tabIndex={-1}
      aria-labelledby="notesModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="notesModalLabel">
              <img
                src={base_url + "images/icons/comment-icon-green.png"}
                alt=""
              />
              {t("notes")}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <textarea
              onChange={(e) => handleChange(e)}
              className="notes-modal-text"
              placeholder="Type your note here."
              defaultValue={note}
            />

            <table className="notes-modal-account">
              <thead>
                <tr>
                  <th colSpan="2">
                    <div className="d-flex align-items-center">
                      <img className="me-2" src={base_url + "images/icons/calc-icon.png"} alt="" /> {t("Account")}
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{t("Total")}</td>
                  <td className="text-end"><span></span>{toFormatPrice(subtotal, { addSymbol: true })}</td>
                </tr>
                <tr>
                  <td>{t("Tax")}</td>
                  <td className="text-end">
                    <div className="d-flex align-items-center gap-2">
                      <div className="placeholder-up-input d-flex align-items-center" style={{ width: "40%" }}>
                        <input className="w-100" inputMode="decimal" placeholder="%" value={taxs ? taxs : ""} onChange={(e) => onTaxPercentChange(e.target.value)} />
                        <span className="ms-1">%</span>
                      </div>
                      <div className="placeholder-up-input" style={{ width: "60%" }}>
                        <input className="w-100" inputMode="decimal" placeholder={t("Amount")} value={taxAmount ? taxAmount : ""} onChange={(e) => onTaxAmountChange(e.target.value)} />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>{t("Shipping and Heading")}</td>
                  <td className="text-end">
                    <div className="placeholder-up-input w-100"><input className="" value={shippings ? shippings : ""} onChange={(e) => { setShipping(e.target.value); setShippings(e.target.value) }} /></div>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td> {t("Total Account")}</td>
                  <td className="text-end "> <span></span><span className="total_purchase_amount">
                    {toFormatPrice(subtotal + (parseFloat(taxAmount) || 0) + parseInt(shippings ? shippings : 0), { addSymbol: true })}</span> </td>
                </tr>
              </tfoot>

            </table>

          </div>
        </div>
      </div>
    </div>
  );
};

export default NotesModalAccounting;
